/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseNode): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;
    const SERIAL_PORT_FEATURE_ID = feature.getSettingValue('SERIAL_PORT');
    const serialPortFeature = project.getFeature(SERIAL_PORT_FEATURE_ID);
    if (!SERIAL_PORT_FEATURE_ID || !serialPortFeature) {
        return [];
    }
    const SERIAL_PORT = `SER_${serialPortFeature.getSettingValue('NAME')}`;
    const MODE = feature.getSettingValue('MODE');
    const varName = `ser_${SERIAL_PORT}_buf`;
    const funcName = `ser_${SERIAL_PORT}_parse`;
    let parseCode = '';

    blocks.push({
        location: 'GLOBAL_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `
let ${varName}="";
`,
    });

    if (MODE === '1') {
        const PACKET_START = feature.getSettingValue('PACKET_START');
        const PACKET_END = feature.getSettingValue('PACKET_END');
        parseCode = `
    const packet_start = "${PACKET_START}"
    const packet_end = "${PACKET_END}"
    const packetStartIndex = ${varName}.indexOf(packet_start);
    const packetEndIndex = ${varName}.indexOf(packet_end, packetStartIndex + packet_start.length);
    if (packetStartIndex !== -1 && packetEndIndex !== -1) {
        data = ${varName}.substring(packetStartIndex + packet_start.length, packetEndIndex);
        complete_data = packet_start + data + packet_end;
        ${varName} = ${varName}.slice(packetEndIndex + packet_end.length);
        if (data.length > 0) {
            /****ser_${SERIAL_PORT}_parse****/
        }
    }
`;
    } else {
        parseCode = `
if (input.length > 0) {
    /****ser_${SERIAL_PORT}_parse****/
    ${varName} = ""
}
`;
    }

    blocks.push({
        location: 'FUNCTION_DEFINITIONS',
        blockType: BlockType.CODE,
        template: `
function ser_${SERIAL_PORT}_parse(input) {
    ${varName} += input
    let data = ${varName};
    let complete_data = ${varName};
    ${parseCode}
    if (${varName}.length > 200) {
        ${varName} = "";
    }
}
`,
    });

    const links = project.getNodeLinks(feature, 'data_available');
    if (links.length > 0 && SERIAL_PORT !== '') {
        blocks.push({
            location: 'on_ser_data_arrival',
            blockType: BlockType.CODE,
            template: `
if (serialInterface === "${SERIAL_PORT}") {
    simulator.updateContext("${SERIAL_PORT_FEATURE_ID}", {
        ...simulator.context.${SERIAL_PORT_FEATURE_ID},
        buffer: data.toString(),
        timestamp: Date.now(),
        type: "recv",
    })
    ser_${SERIAL_PORT}_parse(data.toString());
}
    `,
        });

        for (let i = 0; i < links.length; i++) {
            const link = links[i];
            blocks.push({
                location: `ser_${SERIAL_PORT}_parse`,
                blockType: BlockType.CODE,
                id: link.getSourceId(),
                template: `/****${link.getSourceId()}****/`,
            });
        }
    }
    return blocks;
};
